// extracted by mini-css-extract-plugin
export default {"forumPanel":"EgEhPI9CpBkzI8poxTPL"};